import React, { useEffect, useRef } from 'react';
import type { DynamicComponentProps } from '@/types/commontypes';
import { Input, type InputRef } from 'antd';

const AntText = ({ label, value, onChange }: DynamicComponentProps<string | number>) => {
  const stringValue = typeof value === 'string' ? value : '';
  const textAreaRef = useRef<InputRef>(null);

  useEffect(() => {
    // Modal 애니메이션 완료 후 포커스
    const timer = setTimeout(() => textAreaRef.current?.focus(), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ gridColumn: 'span 2' }}>
      <label>{label}</label>
      <Input.TextArea
        ref={textAreaRef}
        showCount
        maxLength={100}
        allowClear
        autoSize={{ minRows: 5, maxRows: 6 }}
        value={stringValue}
        placeholder="Enter Text"
        onChange={e => onChange(e.target.value)}
        style={{ height: 120, resize: 'none' }}
      />
    </div>
  );
};

export default AntText;
